import { action } from '@ember/object';
import SettingsAgentsBaseController from '../base';
import AgentModel from 'scaleflow/models/agent';

export default class SettingsAgentsAgentEditController extends SettingsAgentsBaseController {
  declare model: AgentModel;

  @action
  cancel() {
    // Rollback changes to avoid persisting unsaved changes
    this.model.rollbackAttributes();
    this.goToListPage();
  }
}
